import { BreadcrumbProps, Breadcrumbs } from "@blueprintjs/core"
import BackButton from "components/Templates/BackButton"
import React from "react"
import classNames from "utils/classNames"
import styles from "./styles.module.scss"
type SubHeaderProps = {
  children?: React.ReactNode
  header?: React.ReactNode
  breadrumbs?: BreadcrumbProps[]
  showBackButton?: boolean
  className?: string
  title?: React.ReactNode
}
const SubHeader = ({
  children,
  breadrumbs,
  header,
  title,
  showBackButton = true,
  className,
}: SubHeaderProps) => {
  return (
    <>
      <section className={styles.base}>
        {(showBackButton || breadrumbs) && (
          <div className="h-full flex items-center">
            {showBackButton && <BackButton className="mr-2" />}
            {title ? (
              typeof title === "string" ? (
                <h6 className="mb-0">{title}</h6>
              ) : (
                title
              )
            ) : null}
            {breadrumbs && <Breadcrumbs items={breadrumbs} />}
          </div>
        )}
        {header}
      </section>
      <main className={classNames(styles.content, className)}>{children}</main>
    </>
  )
}

export default SubHeader
